<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    style="width: 600px;"
    tabindex="-1"
    id="offcanvasManageBranches"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-top-nav border offcanvas-header py-2">
      {{ $t('Manage Branches')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>
    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div
        class="bg-white border-bottom mb-3 px-3 py-2 sticky-top"
      >
        <div class="d-flex">
          <div class="row g-3 py-2">
            <b style="font-size: 18px;" class="mt-2">
              {{ data.name }}
            </b>
            <div
              class="d-flex mt-0 "
              style="font-size: 13px;"
            >
              <label
                class="pe-2"
              >
                {{ $t('Status')  }}
                <span
                  :class="['badge', data.active? 'bg-success': 'bg-danger']"
                >
                  {{ data.active? $t('Active'): $t('Inactive') }}
                </span>
              </label>
              <label
                class="pe-2"
              >
                {{ $t('Type')  }}
                <span
                  :class="['badge', data.type == 'Configurale'? 'bg-info text-dark': 'bg-secondary text-white']"
                >
                  {{ $t(data.type) }}
                </span>
              </label>
              <label
                class="pe-2"
              >
                {{ $t('Last Update') + ': ' + formatDateTime(data.updated_at) }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="px-3 pb-3">
        <p class="text-muted small mb-2">
          <i class="fa-solid fa-circle-info me-1"/>
          {{ $t('Turn on the switch to enable this product in a branch and set its specific pricing.') }}
        </p>

        <div>
          <template
            v-for="(branch, branchIndex) in form.branches"
          >
            <item-manage-branch-form
              :base-form="form"
              :index="branchIndex"
              :branch="branch"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="bg-white border-top justify-content-center modal-footer py-2" v-if="!loading">
      <ladda
        text="Save"
        :btn-class="'btn btn-theme btn-block me-2'"
        :loading="loadingSave"
        :disabled="v$.$invalid"
        @click="handleSave"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-branch";
import Ladda from '@/plugins/Ladda.vue';
import { Products } from '@/services/endpoint/products.service';
import moment from "moment";
import Popper from "vue3-popper";
import { formatProductBranchData } from '@/utils/helpers';
import ItemManageBranchForm from './ItemManageBranchForm.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.form);
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    Popper,
    ItemManageBranchForm
  },
  data() {
    return {
      loading: true,
      loadingSave: false,
      hasPermission: false,
      form: {
        branches: []
      },
      data: {}
    }
  },
  methods: {
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    async fetchData() {
      this.loading = true;
      let vm = this;
      await Products.getUpdateBranch(this.id).then(res => {
        this.data = res.data.data;
        this.form = formatProductBranchData(res.data.data);

        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
        }
        this.loading = false;
			  // throw err;
      });
    },
    setParamsBeforeSendSave() {
      const pick = ({ id, is_active, is_in_stock, price_override }) =>
        ({ id, is_active, is_in_stock, price_override });

      const branches = this.form.is_config
        ? this.form.branches.flatMap(b => [
            { id: b.id, is_active: b.is_active, is_in_stock: b.is_in_stock }, // สาขาตัวแม่
            ...(b.variants || []).map(pick) // สาขาตัวลูก
          ])
        : this.form.branches.map(pick);

      return { branches };
    },
    async handleSave() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Products.updateBranch(this.id, this.setParamsBeforeSendSave()).then(res => {
        // this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        this.loadingSave = false;
      });
    },
  },
  mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas', () => {
      this.fetchData();
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$emit('close');
    });
  }
}
</script>
